.conversational-search-messages-terms-and-conditions-external-origin {
  @media (max-width: 1100px) {
    container-type: inline-size;
  }

  qds-inline-link {
    cursor: pointer;
  }

  &-header {
    font-size: 22px;
    line-height: 30px;

    &__icon {
      margin-left: 4px;
    }
  }
}
